var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "sync-email-terms-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
      "header-class": "justify-content-center",
      "modal-dialog-size": "xl",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "header-logos" }, [
              _c("div", { staticClass: "logo-wrapper" }, [
                _c("img", {
                  staticClass: "w-100",
                  attrs: {
                    height: "auto",
                    src: require("@Shared/@Assets/img/mg.png"),
                    alt: _vm.$t("global.words.filogixLogo"),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "logo-wrapper" }, [
                _c("img", {
                  staticClass: "w-100",
                  attrs: {
                    height: "auto",
                    src: require("@Broker/@Assets/img/nylas-gray.svg"),
                    alt: _vm.$t("global.words.nylasLogo"),
                  },
                }),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-section mt-4" }, [
              _vm.resyncEmail
                ? _c("h4", { staticClass: "bold mt-2" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("email.nylas.resyncWithNylas")) +
                        "\n      "
                    ),
                  ])
                : _c("div", [
                    _c("h4", { staticClass: "bold mt-2" }, [
                      _vm._v("Expert Pro + Nylas"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-gray small" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("email.nylas.doorrHasPartneredWithNylas")
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]),
            ]),
            _vm._v(" "),
            _vm.resyncEmail
              ? _c("div", { staticClass: "modal-section" }, [
                  _c("p", { staticClass: "text-gray small" }, [
                    _c("span", { staticClass: "bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("email.nylas.reEnableEmailTracking")) +
                          "\n        "
                      ),
                    ]),
                  ]),
                ])
              : _c("div", { staticClass: "modal-section" }, [
                  _c("p", { staticClass: "text-gray small m-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("email.nylas.doorrWillNotStoreAnyEmails")
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-gray small" }, [
                    _c("span", { staticClass: "bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("email.nylas.doorrWillNeverDeleteAnyEmails")
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]),
                ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-section" },
              [
                _c("i18n", {
                  staticClass: "text-gray small",
                  attrs: {
                    tag: "p",
                    path: "email.nylas.ifYouHaveAnyQuestions",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "email",
                      fn: function () {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "text-primary",
                              attrs: {
                                href: "mailto:expertprosupport@finastra.com",
                              },
                            },
                            [_vm._v("expertprosupport@finastra.com")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: { href: _vm.getNylasConnectUrl() },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.resyncEmail
                        ? _vm.$t("global.words.resync")
                        : _vm.$t("global.words.connect")
                    ) +
                    "\n      "
                ),
                _c("i", {
                  staticClass: "fa fa-external-link pl-1",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }